import { render } from "./BalTable.vue?vue&type=template&id=1a251b4a&ts=true"
import script from "./BalTable.vue?vue&type=script&lang=ts"
export * from "./BalTable.vue?vue&type=script&lang=ts"

import "./BalTable.vue?vue&type=style&index=0&id=1a251b4a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__